<script>
export default {
  name: "change-password-modal",
  props: {
    isResetModalShown: Boolean,
  },
  data: function() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    };
  },
  methods: {
    async changePassword() {
      this.$store.commit("toggleChangePasswordModal", false);
      var result = await this.$store.dispatch("getRequest", { controller: "login", method: `ChangePassword`, parameters: { currentPassword: this.currentPassword, newPassword: this.newPassword } });
      if (result && result.success) {
        this.$store.commit("setMessage", { title: "Password Successfuly Updated", type: "info", content: result.message });
      } else if (result) {
        this.$store.commit("setMessage", { title: "Unable to Change password", type: "error", content: result.message });
      } else {
        this.$store.commit("setMessage", { title: "Unable to Change password", type: "error", content: "Unable to change password - Please contact an Administrator." });
      }
    },
    onModalShown: function() {
      this.newPassword = "";
      this.confirmNewPassword = "";
    },
    onModalClose: function() {
      this.$store.commit("toggleChangePasswordModal", false);
    },
  },
  computed: {
    modalVisible: function() {
      return this.$store.state.changePasswordShown;
    },
    matchingPasswords: function() {
      return this.newPassword == this.confirmNewPassword;
    },
    validFormat: function() {
      if (this.newPassword) {
        var regex = new RegExp("(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
        return regex.test(this.newPassword);
      }
      return true;
    },
  },
};
</script>
<template>
  <div>
    <b-modal id="change-password-modal" title="Change Password" v-on:shown="onModalShown" v-on:hidden="onModalClose" :hide-footer="false" v-model="modalVisible">
      <div class="row">
        <div class="col-12">
          <label class="title-text">Current Password</label>
          <input v-model="currentPassword" class="form-control mr-sm-2" type="password" placeholder="Enter current password" aria-label="Current Password" />
          <br />
          <label class="title-text">New Password</label>
          <input v-model="newPassword" class="form-control mr-sm-2" type="password" placeholder="Enter new password" aria-label="New Password" />
          <i v-if="!validFormat" class="errorText">Password must be at least 8 characters long with at least one numeric and upper case character</i>
          <br />
          <label class="title-text">Confirm New Password</label>
          <input v-model="confirmNewPassword" class="form-control mr-sm-2" type="password" placeholder="Confirm new password" aria-label="Confirm New Password" />
          <i v-if="!matchingPasswords" class="errorText">New password and confirmation do not match</i>
        </div>
      </div>

      <template v-slot:modal-footer="{ cancel }">
        <div class="row" style="width:100%">
          <div class="col-6" style="padding-left:0px;">
            <b-button size="sm" variant="danger" block v-on:click="cancel()">
              Cancel
            </b-button>
          </div>
          <div class="col-6" style="padding-right:0px;">
            <b-button :disabled="!matchingPasswords || !validFormat" size="sm" variant="success" block v-on:click="changePassword()">
              Update Password
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style scoped>
.errorText {
  font-size: 12px;
  color: red;
}
</style>
